import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ContactSection = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) return setError("Name is required");
    if (!/^\d{10}$/.test(formData.phone))
      return setError("Enter valid 10 digit mobile number");

    try {
      setLoading(true);
      setError("");

      const googleData = new FormData();
      googleData.append("Name", formData.name);
      googleData.append("Phone", formData.phone);

      const crmData = {
        name: formData.name,
        phone: formData.phone,
        listId: "69b1245f0dbd923cc18d4d61",
        redirect: "",
      };

      const googleRes = await fetch(
        "https://script.google.com/macros/s/AKfycby5yRHDZvWnMVJp11vGwz5ZFB8fXdzeZUf8roAHyumww2vsghJ00B7GZ7XuXSMq5nWq/exec",
        {
          method: "POST",
          body: googleData,
        }
      );

      if (!googleRes.ok) throw new Error("Submission failed");

      // Fire CRM in background — don't block user flow on CRM errors
      fetch(
        "https://enterprise.godial.cc/meta/api/externals/contact/add?access_token=nbcLc99ivtoh5FO8xqGEOZEW6ddcb4szdtvHdVNCeTh980VQNehbfScBK0MvbQTb",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(crmData),
        }
      ).catch((err) => console.warn("CRM sync failed:", err));

      setFormData({ name: "", phone: "" });
      navigate("/thank-you");

    } catch (err) {
      console.error("Lead submit error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="w-full bg-white">
      <div className="max-w-7xl mx-auto shadow-lg rounded-xl overflow-hidden">
        <div className="flex flex-col lg:flex-row">
          {/* IMAGE */}
          <div className="w-full lg:w-1/2 order-1 sm:order-1 md:order-2 lg:order-2">
            <img
              src="/Images/BANNER/1.jpg"
              alt="Siddhi project in Kharghar"
              className="w-full object-cover 
               h-[240px] sm:h-[280px] 
               md:h-[320px] 
               lg:h-full"
            />
          </div>

          {/* FORM */}
          <div className="w-full lg:w-1/2 p-6 sm:p-8 order-2 sm:order-2 md:order-1 lg:order-1">
            <h2 className="text-2xl text-center font-semibold text-[#090C6A] mb-6 lg:text-left">
              Schedule a Site Visit
            </h2>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name*"
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md px-4 py-3 focus:ring-2 focus:ring-[#090C6A] outline-none"
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md px-4 py-3 focus:ring-2 focus:ring-[#090C6A] outline-none"
              />

              {error && (
                <p className="text-red-500 text-sm text-center">{error}</p>
              )}

              <div className="flex items-start gap-2 text-xs text-gray-600">
                <input type="checkbox" className="mt-1" defaultChecked />
                <p>
                  I consent to the processing of provided data according to{" "}
                  <span
                    className="text-[#090C6A] underline cursor-pointer"
                    onClick={() => {
                      navigate("/policy");
                      window.scrollTo(0, 0);
                    }}
                  >
                    Privacy Policy
                  </span>{" "}
                  | Terms & Conditions.
                </p>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#090c6a] hover:bg-[#1218A6] text-white py-3 rounded-lg transition disabled:opacity-60"
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;